export function disableAnalytics(id) {
  window[`ga-disable-${id}`] = true;
}
export function enableAnalytics(id) {
  const key = `ga-disable-${id}`;
  if (key in window)
    delete window[key];
}
